import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { UserRegistrationService } from '../services/user-registration.service';
import { User } from '../models/user.model';


@Injectable()
export class UserRegistrationResolver implements Resolve<User> {

  constructor(public service: UserRegistrationService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.service.validate(route.params['guid']);
  }
}
